import { Box, Typography } from '@material-ui/core'
import React, { Fragment } from 'react'
import i18n from 'i18next'
import AccordionModel from './AccordionModel'

export const BackgroundViewer = ({ background }) => {
  const groupedBackground = Array.isArray(background)
    ? background.reduce((grouped, current) => {
        const currentCategory = current.background_type
        grouped[currentCategory] = grouped[currentCategory] || []
        grouped[currentCategory] = [...grouped[currentCategory], current]

        return grouped
      }, {})
    : Object.values(background).reduce((grouped, current) => {
        const currentCategory = current.background_type
        grouped[currentCategory] = grouped[currentCategory] || []
        grouped[currentCategory] = [...grouped[currentCategory], current]

        return grouped
      }, {})
  return (
    <Fragment>
      <Box style={{ width: '100%' }}>
        <Typography variant="h2">{i18n.t('job_offer.job_apply.background')}</Typography>
        {Object.entries(backgroundCategory).map(([currentIndex, category]) => (
          <Fragment>
            {groupedBackground[currentIndex] && (
              <div style={{ marginTop: '16px' }}>
                <Typography variant="h4">{category}</Typography>
                {groupedBackground[currentIndex].map((current) => (
                  <AccordionModel current={current} />
                ))}
              </div>
            )}
          </Fragment>
        ))}
      </Box>
    </Fragment>
  )
}

const backgroundCategory = {
  education: i18n.t('profile.background.education.label'),
  experience: i18n.t('profile.background.experience.label')
}
